import { GraphModel } from '../../graph/graph.model';
import { z } from 'zod/v3';
import { ok } from 'neverthrow';
import { ApplicableContext } from '../../actions/framework';
import { BaseAction } from '../../actions/framework';
import { GRAPH_ACTION_GROUP } from './constants';
import { Routes } from '../../routes';

type Params = {
  name?: string;
  startingEraQl?: string;
};

export class NewDatasetAction extends BaseAction<Params> {
  title = 'New Dataset';
  description = 'Navigates to the dataset creation page';
  inputSchema = z.object({
    name: z.string().optional(),
    startingEraQl: z.string().optional(),
  });
  shortcut = ['ctrl', 'n'];
  group = GRAPH_ACTION_GROUP;
  icon = 'plus';
  priority = 1;

  constructor(
    private readonly navigator: {
      push: (opts: {
        route: string;
        title?: string;
        params: Record<string, string | undefined>;
      }) => void;
    }
  ) {
    super();
  }

  applicable(context: ApplicableContext): boolean {
    return context.isInScope(GraphModel);
  }

  async execute(input: z.infer<typeof this.inputSchema>) {
    const datasetId = Math.random().toString(36).substring(2, 10);
    this.navigator.push({
      route: Routes.dataset.new(datasetId).toString(),
      params: {
        name: input.name,
        startingEraQl: input.startingEraQl,
      },
    });

    return ok({});
  }
}
